import { MessageOutlined, StarOutlined } from '@ant-design/icons';
import { INTERACTION_TYPES, type InteractionType } from '@cult/domain';
import type { ReactNode } from 'react';
import styles from './InteractionTone.module.scss';

type InteractionTypeMeta = {
  label: string;
  icon: ReactNode;
  accent: string;
  toneClassName: string | undefined;
};

export const INTERACTION_TYPE_META: Record<InteractionType, InteractionTypeMeta> = {
  [INTERACTION_TYPES.PRAISE]: {
    label: 'Praise',
    icon: <StarOutlined />,
    accent: 'var(--ant-color-primary)',
    toneClassName: styles.praise,
  },
  [INTERACTION_TYPES.DIRECT_FEEDBACK]: {
    label: 'Direct Feedback',
    icon: <MessageOutlined />,
    accent: 'var(--cult-feedback)',
    toneClassName: styles.feedback,
  },
};
